export default "__VITE_ASSET__CPT0KwWb__"